import React from 'react';

import { Input } from '@yuhuinc/ui-library/';

const ServiceAndUtilityAnswerInput = ({
  setFieldValue,
  question,
  isChild,
  parentIndex,
  selectedParentAnswerIndex,
  index,
  serviceOrUtility,
  isMobile,
}) => {
  if (isChild) {
    return (
      <Input
        disabled={false}
        isMobile={isMobile}
        placeholder={question.conditional_answers[0].name}
        value={question.conditional_answers[0].value}
        handleChange={(e) => {
          setFieldValue(
            `${serviceOrUtility}[${parentIndex}].answers[${selectedParentAnswerIndex}].conditional_questions[${index}].conditional_answers[0].value`,
            e.target.value
          );
        }}
      />
    );
  }
  return (
    <Input
      disabled={false}
      isMobile={isMobile}
      placeholder={question.answers[0].answer_name}
      value={question.answers[0].answer_value}
      handleChange={(e) => {
        setFieldValue(
          `${serviceOrUtility}[${parentIndex}].answers[0].answer_value`,
          e.target.value
        );
      }}
    />
  );
};

export { ServiceAndUtilityAnswerInput };
